import script from "./skeleton-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./skeleton-loader.vue?vue&type=script&setup=true&lang=js"

import "./skeleton-loader.vue?vue&type=style&index=0&id=c6092b86&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6092b86"]])

export default __exports__